module.exports = __webpack_public_path__ + "static/media/callToAction.42a7c984.png";